import { applySearchForName } from './applySearchForName';

export const useFullNameInRoute = (fullName: string | undefined) =>
  [decodeURIComponent(fullName ?? ''), applySearchForName()] as const;
